<template>
  <div class="etms-router-body">
    <el-tabs v-model="activename" @tab-click="handleClick">
      <el-tab-pane name="versionmanage" label="版本管理">
        <div class="etms-router-search">
          <span class="etms-router-search-label fl">供应商：</span>
          <el-select size="mini" placeholder="请选择供应商" v-model="version.search.ChannelSupplyId" class="etms-router-search-element fl" filterable clearable>
            <el-option v-for="item in supplylist" :key="item.id" :value="item.id" :label="item.channelSupplyName"></el-option>
          </el-select>
          <span class="etms-router-search-label fl">渠道：</span>
          <el-select size="mini" placeholder="请选择渠道" v-model="version.search.ChannelId" class="etms-router-search-element fl" filterable clearable>
            <el-option v-for="item in version.search.channellist" :key="item.id" :value="item.id" :label="item.channelName"></el-option>
          </el-select>
          <span class="etms-router-search-label fl">版本号：</span>
          <el-input size="mini" placeholder="请填写版本号搜索" v-model="version.search.Version" class="etms-router-search-element fl"></el-input>
          <el-tooltip class="item" content="添加" placement="top">
            <el-button size="mini" type="primary" icon="el-icon-plus" class="etms-router-search-button fr" @click="insertVersion"></el-button>
          </el-tooltip>
          <el-tooltip class="item" content="搜索" placement="top">
            <el-button size="mini" type="primary" icon="el-icon-search" class="etms-router-search-button fr" @click="searchVersionClick"></el-button>
          </el-tooltip>
          <div class="clear"></div>
        </div>
        <el-table :data="version.versionlist" :border="true" class="etms-router-list">
          <el-table-column type="index" label="序号" align="center"></el-table-column>
          <el-table-column label="供应商" :formatter="formatterSupplyName"></el-table-column>
          <el-table-column label="渠道" :formatter="formatterVersionChannelName"></el-table-column>
          <el-table-column label="版本号" prop="version"></el-table-column>
          <el-table-column label="生效时间段" :formatter="formatterEffectTime"></el-table-column>
          <el-table-column label="状态" prop="state" width="150px" align="center" :formatter="formatterState"></el-table-column>
          <el-table-column label="操作" width="150px" align="center">
            <template slot-scope="scope">
              <el-tooltip class="item" content="修改" placement="top">
                <el-button size="mini" type="primary" icon="el-icon-edit-outline" circle @click="editVersion(scope.row)"></el-button>
              </el-tooltip>
              <el-tooltip class="item" content="删除" placement="top">
                <el-button size="mini" type="danger" icon="el-icon-delete" circle @click="deleteVersion(scope.row)"></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        <el-dialog :title="version.dialogVersion.dialogtitle" :visible.sync="version.dialogVersion.dialogvisible" :modal-append-to-body="false" center width="550px">
          <el-form :ref="version.dialogVersion.form.formname" :model="version.dialogVersion.form" :rules="version.dialogVersion.form.rules" label-width="100px" class="etms-dialog-form">
            <el-form-item label="供应商：" prop="ChannelSupplyId">
              <el-select size="mini" placeholder="请选择供应商" v-model="version.dialogVersion.form.ChannelSupplyId" class="el-width-200" filterable>
                <el-option v-for="item in supplylist" :key="item.id" :value="item.id" :label="item.channelSupplyName"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="渠道：" prop="ChannelId">
              <el-select size="mini" placeholder="请选择渠道" v-model="version.dialogVersion.form.ChannelId" class="el-width-200" filterable>
                <el-option v-for="item in version.dialogVersion.channellist" :key="item.id" v-model="item.id" :label="item.channelName"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="价格版本：" prop="PriceVersionId">
              <el-select size="mini" placeholder="请选择有效的价格版本" v-model="version.dialogVersion.form.PriceVersionId" class="el-width-200" filterable>
                <el-option v-for="item in version.dialogVersion.priceversionlist" :key="item.id" :value="item.id" :label="item.version"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="版本名称：" prop="Version">
              <el-input size="mini" placeholder="请输入版本名称" v-model="version.dialogVersion.form.Version" class="el-width-200"></el-input>
            </el-form-item>
            <el-form-item label="生效时间：" prop="EffectTime">
              <el-date-picker size="mini" v-model="version.dialogVersion.form.EffectTime" type="datetimerange" align="right" unlink-panels range-separator="至" start-placeholder="生效时间" end-placeholder="结束时间" :picker-options="constant.effectTimeOptions" class="el-width-300">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="状态：" prop="State">
              <el-select size="mini" placeholder="请选择版本状态" v-model="version.dialogVersion.form.State" class="el-width-200">
                <el-option v-for="item in constant.discountVersionStates" :key="item.value" :value="item.value" :label="item.label"></el-option>
              </el-select>
            </el-form-item>
            <div class="clear"></div>
          </el-form>
          <span class="dialog-tips">
            {{message.tips.insertDiscountTips}}
          </span>
          <div slot="footer" class="dialog-footer">
            <el-button size="mini" type="primary" @click="dialogVersionSave">确 定</el-button>
          </div>
        </el-dialog>
      </el-tab-pane>
      <el-tab-pane name="discountmanage" label="折扣管理">
        <div class="etms-router-search">
          <span class="etms-router-search-label fl">供应商：</span>
          <el-select size="mini" placeholder="请选择供应商" v-model="discount.search.ChannelSupplyId" class="etms-router-search-element fl" filterable>
            <el-option v-for="item in supplylist" :key="item.id" :value="item.id" :label="item.channelSupplyName"></el-option>
          </el-select>
          <span class="etms-router-search-label fl">渠道：</span>
          <el-select size="mini" placeholder="请选择渠道" v-model="discount.search.ChannelId" class="etms-router-search-element fl" filterable>
            <el-option v-for="item in discount.search.channellist" :key="item.id" :value="item.id" :label="item.channelName"></el-option>
          </el-select>
          <span class="etms-router-search-label fl">折扣版本：</span>
          <el-select size="mini" v-model="discount.search.Version" class="etms-router-search-element el-width-100 fl" filterable>
            <el-option v-for="item in discount.search.versionlist" :key="item.id" :value="item.id" :label="item.version"></el-option>
          </el-select>
          <span class="etms-router-search-label fl">物品类型：</span>
          <el-select size="mini" v-model="discount.search.ItemType" class="etms-router-search-element el-width-100 fl" filterable>
            <el-option v-for="item in discount.search.itemtypelist" :key="item.value" :value="item.value" :label="item.label"></el-option>
          </el-select>
          <span class="etms-router-search-label fl">线路：</span>
          <el-select size="mini" v-model="discount.search.ChannelLineId" class="etms-router-search-element el-width-100 fl" filterable>
            <el-option v-for="item in discount.search.channellinelist" :key="item.id" :value="item.id" :label="item.lineName"></el-option>
          </el-select>
          <el-dropdown @command="handleCommand" class="etms-router-search-button fr">
            <el-button size="mini" type="primary">
              操作<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="insertdiscount">添加折扣</el-dropdown-item>
              <el-dropdown-item command="passdiscountsetting">通折设置</el-dropdown-item>
              <el-dropdown-item command="discountbatchsetting">折扣批设</el-dropdown-item>
              <el-dropdown-item command="importdiscount">导入折扣</el-dropdown-item>
              <el-dropdown-item command="exportdiscount">导出折扣</el-dropdown-item>
              <el-dropdown-item command="deletediscount">删除折扣</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <div class="clear"></div>
        </div>
        <table cellspacing="0" cellpadding="0" border="1" class="line-price-table">
          <tr>
            <th>起始值(不包含)</th>
            <th style="width:11%;">结束值(包含)</th>
            <th style="width:11%;">计费类型</th>
            <th style="width:11%;">起始价</th>
            <th style="width:11%;">百分比</th>
            <th style="width:11%;">值单位</th>
            <th style="width:11%;">单价</th>
            <th style="width:11%;">计算模式</th>
            <th style="width:11%;">操作</th>
          </tr>
          <template v-for="item in discount.search.pricelist">
            <tr :key="item.PriceTypeId" style="background-color:#DFE1E7;">
              <td colspan="9" style="color:#FF7F00;">{{item.PriceTypeName}}</td>
            </tr>
            <tr v-for="discount in item.DiscountList" :key="discount.DiscountId">
              <td>{{discount.StartValue}}</td>
              <td>{{discount.EndValue}}</td>
              <td>{{discount.DiscountBillingType}}</td>
              <td>{{discount.StartPrice}}</td>
              <td>{{discount.Percent}}</td>
              <td>{{discount.ValueUnit}}</td>
              <td>{{discount.UnitPrice}}</td>
              <td>{{discount.ManualCalcu?'手动':'自动'}}</td>
              <td>
                <el-tooltip class="item" effect="dark" content="修改" placement="top">
                  <el-button size="mini" type="primary" @click="editDiscount(discount)" icon="el-icon-edit-outline" circle></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="删除" placement="top">
                  <el-button size="mini" type="danger" @click="deleteDiscount(discount)" icon="el-icon-delete" circle></el-button>
                </el-tooltip>
              </td>
            </tr>
          </template>
          <tr style="background-color:#DFE1E7;">
            <td colspan="9" style="color:#FF7F00;">线路目的地</td>
          </tr>
          <tr>
            <td colspan="9">
              <span v-for="(item,index) in discount.search.channellinepurposelist" :key="index" class="span-padding">{{item}}</span>
            </td>
          </tr>
        </table>
      </el-tab-pane>
    </el-tabs>

    <el-dialog :title="dialogPassDiscount.dialogtitle" :visible.sync="dialogPassDiscount.dialogvisible" :modal-append-to-body="false" center width="700px">
      <el-tabs v-model="dialogPassDiscount.activename">
        <el-tab-pane name="baseinfo" label="基本信息">
          <el-form :model="dialogPassDiscount.form" :rules="dialogPassDiscount.form.rules" label-width="100px" class="el-form-half etms-dialog-form">
            <el-form-item label="供应商：">
              <el-select size="mini" placeholder="请选择供应商" v-model="dialogPassDiscount.form.SupplyId" class="el-width-200" filterable>
                <el-option v-for="item in supplylist" :key="item.value" :value="item.value" :label="item.label"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="渠道：">
              <el-select size="mini" placeholder="请选择渠道" v-model="dialogPassDiscount.form.ChannelId" class="el-width-200" filterable>
                <el-option v-for="item in dialogPassDiscount.channellist" :key="item.value" :value="item.value" :label="item.label"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="折扣版本：">
              <el-select size="mini" v-model="dialogPassDiscount.form.DiscountVersion" class="el-width-200" filterable>
                <el-option v-for="item in dialogPassDiscount.discountversionlist" :key="item.value" :value="item.value" :label="item.label"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="包裹分类：">
              <el-select size="mini" v-model="dialogPassDiscount.form.ParcelTypeIds" class="el-width-200" multiple collapse-tags filterable>
                <el-option v-for="item in dialogPassDiscount.parceltypelist" :key="item.value" :value="item.value" :label="item.label"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="线路：">
              <el-select size="mini" v-model="dialogPassDiscount.form.ChannelLineIds" class="el-width-200" multiple collapse-tags filterable>
                <el-option v-for="item in dialogPassDiscount.channellinelist" :key="item.value" :value="item.value" :label="item.label"></el-option>
              </el-select>
            </el-form-item>
            <div class="clear"></div>
          </el-form>
        </el-tab-pane>
        <el-tab-pane name="discountinfo" label="折扣信息">
          <el-table :data="dialogPassDiscount.form.discountlist" :border="true" class="etms-router-list">
            <el-table-column label="序号" type="index" align="center"></el-table-column>
            <el-table-column label="起始值(不包含)">
              <template slot-scope="scope">
                <el-input size="mini" type="number" v-model="scope.row.StartValue" class="el-width-100"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="结束值(包含)" align="center">
              <template slot-scope="scope">
                <el-input size="mini" type="number" v-model="scope.row.EndValue" class="el-width-100"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="折扣(%)" align="center">
              <template slot-scope="scope">
                <el-input size="mini" type="number" v-model="scope.row.Percent" class="el-width-100"></el-input>
              </template>
            </el-table-column>
            <el-table-column align="center">
              <template slot="header" slot-scope="scope">
                <el-button size="mini" type="primary" icon="el-icon-plus" circle @click="insertPassDiscountList"></el-button>
              </template>
              <template slot-scope="scope">
                <el-button size="mini" type="danger" icon="el-icon-delete" circle @click="deletePassDiscountList(scope.$index)"></el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
      <span class="dialog-tips">
        {{message.tips.passDiscountSettingTips}}
      </span>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="dialogPassDiscountSave">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="dialogDiscountBatchSetting.dialogtitle" :visible.sync="dialogDiscountBatchSetting.dialogvisible" :modal-append-to-body="false" center width="1100px">
      <el-tabs v-model="dialogDiscountBatchSetting.activename">
        <el-tab-pane label="基本信息" name="baseinfo">
          <el-form :model="dialogDiscountBatchSetting.form" :rules="dialogDiscountBatchSetting.form.rules" :ref="dialogDiscountBatchSetting.form.formname" label-width="100px" class="el-form-half etms-dialog-form">
            <el-form-item label="供应商：">
              <el-select size="mini" placeholder="请选择供应商" v-model="dialogDiscountBatchSetting.form.SupplyId" class="el-width-200" filterable>
                <el-option v-for="item in supplylist" :key="item.value" :value="item.value" :label="item.label"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="渠道：">
              <el-select size="mini" placeholder="请选择渠道" v-model="dialogDiscountBatchSetting.form.ChannelId" class="el-width-200" filterable>
                <el-option v-for="item in dialogDiscountBatchSetting.channellist" :key="item.value" :value="item.value" :label="item.label"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="版本：">
              <el-select size="mini" placeholder="请选择折扣版本" v-model="dialogDiscountBatchSetting.form.VersionId" class="el-width-200" filterable>
                <el-option v-for="item in dialogDiscountBatchSetting.discountversionlist" :key="item.value" :value="item.value" :label="item.label"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="包裹分类：">
              <el-select size="mini" placeholder="请选择包裹分类" v-model="dialogDiscountBatchSetting.form.parceltypelist" class="el-width-200" filterable multiple collapse-tags>
                <el-option v-for="item in dialogDiscountBatchSetting.parceltypelist" :key="item.value" :value="item.value" :label="item.label"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="线路：">
              <el-select size="mini" placeholder="请选择渠道线路" v-model="dialogDiscountBatchSetting.form.channellinelist" class="el-width-200" filterable multiple collapse-tags>
                <el-option v-for="item in dialogDiscountBatchSetting.channellinelist" :key="item.value" :value="item.value" :label="item.label"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="折扣信息" name="discountinfo">
          <el-table :data="dialogDiscountBatchSetting.form.discountlist" :border="true" class="etms-router-list">
            <el-table-column label="序号" type="index" align="center" width="45px"></el-table-column>
            <el-table-column label="费用类型" align="center">
              <template slot-scope="scope">
                <el-select size="mini" v-model="scope.row.PriceTypeId" class="el-width-60">
                  <el-option v-for="item in dialogDiscountBatchSetting.pricetypelist" :key="item.value" :value="item.value" :label="item.label"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="起始值(不包含)" align="center" width="120px">
              <template slot-scope="scope">
                <el-input size="mini" type="number" v-model="scope.row.StartValue" class="el-width-60"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="结束值(包含)" align="center">
              <template slot-scope="scope">
                <el-input size="mini" type="number" v-model="scope.row.EndValue" class="el-width-60"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="计价分类" align="center">
              <template slot-scope="scope" align="center">
                <el-select size="mini" v-model="scope.row.PriceBillingType" class="el-width-70" filterable @change="priceBillingTypeChange(scope.row)">
                  <el-option v-for="item in constant.discountBillingTypes" :key="item.value" :value="item.value" :label="item.label"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="起始价" align="center">
              <template slot-scope="scope">
                <el-input size="mini" type="number" v-model="scope.row.StartPrice" class="el-width-60" v-show="scope.row.StartShow"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="百分比" align="center">
              <template slot-scope="scope">
                <el-input size="mini" type="number" v-model="scope.row.Percent" class="el-width-60" v-show="scope.row.PercentShow"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="目标分类" align="center">
              <template slot-scope="scope">
                <el-select size="mini" v-model="scope.row.TargetPriceTypeId" class="el-width-60" v-show="scope.row.TargetShow">
                  <el-option v-for="item in dialogDiscountBatchSetting.pricetypelist" :key="item.value" :value="item.value" :label="item.label" :disabled="item.value === scope.row.PriceTypeId"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="值单位" align="center">
              <template slot-scope="scope">
                <el-input size="mini" type="number" v-model="scope.row.ValueUnit" class="el-width-60" v-show="scope.row.ValueUnitShow"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="单价" align="center">
              <template slot-scope="scope">
                <el-input size="mini" type="number" v-model="scope.row.UnitPrice" class="el-width-60" v-show="scope.row.UnitPriceShow"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="模式" align="center" width="80px">
              <template slot-scope="scope">
                <el-checkbox v-model="scope.row.ManualCalcu" label="手动"></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column width="50px" align="center">
              <template slot="header" slot-scope="scope">
                <el-button size="mini" type="primary" icon="el-icon-plus" circle @click="insertBarchSettingDiscount"></el-button>
              </template>
              <template slot-scope="scope">
                <el-button size="mini" type="danger" icon="el-icon-delete" circle @click="deleteBarchSettingDiscount(scope.$index)"></el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
      <span class="dialog-tips">
        {{message.tips.discountBatchSettingTips}}
      </span>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="dialogBatchSettingSave">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="dialogInsertDiscount.dialogtitle" :visible.sync="dialogInsertDiscount.dialogvisible" :modal-append-to-body="false" center>
      <el-form :model="dialogInsertDiscount.form" :rules="dialogInsertDiscount.form.rules" :ref="dialogInsertDiscount.form.formname" label-width="120px" class="el-form-half etms-dialog-form">
        <el-form-item label="供应商：">
          <el-select size="mini" placeholder="请选择供应商" v-model="dialogInsertDiscount.form.SupplyId" class="el-width-200" filterable>
            <el-option v-for="item in supplylist" :key="item.value" :value="item.value" :label="item.label"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="渠道：">
          <el-select size="mini" placeholder="请选择渠道" v-model="dialogInsertDiscount.form.ChannelId" class="el-width-200" filterable>
            <el-option v-for="item in dialogInsertDiscount.channellist" :key="item.value" :value="item.value" :label="item.label"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="折扣版本：">
          <el-select size="mini" placeholder="请选择折扣版本" v-model="dialogInsertDiscount.form.DiscountVersionId" class="el-width-200" filterable>
            <el-option v-for="item in dialogInsertDiscount.discountversionlist" :key="item.value" :value="item.value" :label="item.label"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="包裹类型：">
          <el-select size="mini" placeholder="请选择包裹类型" v-model="dialogInsertDiscount.form.ParcelTypeId" class="el-width-200" filterable>
            <el-option v-for="item in dialogInsertDiscount.parceltypelist" :key="item.value" :value="item.value" :label="item.label"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="渠道线路：">
          <el-select size="mini" placeholder="请选择渠道线路" v-model="dialogInsertDiscount.form.ChannelLineId" class="el-width-200" filterable>
            <el-option v-for="item in dialogInsertDiscount.channellinelist" :key="item.value" :value="item.value" :label="item.label"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="费用类型：">
          <el-select size="mini" placeholder="请选择费用类型" v-model="dialogInsertDiscount.form.PriceTypeId" class="el-width-200" filterable>
            <el-option v-for="item in dialogInsertDiscount.pricetypelist" :key="item.value" :value="item.value" :label="item.label"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="起始值(不包含)：">
          <el-input size="mini" type="number" placeholder="请填写起始值" v-model="dialogInsertDiscount.form.StartValue" class="el-width-200"></el-input>
        </el-form-item>
        <el-form-item label="结束值(包含)：">
          <el-input size="mini" type="number" placeholder="请填写结束值" v-model="dialogInsertDiscount.form.EndValue" class="el-width-200"></el-input>
        </el-form-item>
        <el-form-item label="计价分类：">
          <el-select size="mini" v-model="dialogInsertDiscount.form.PriceBillingType" class="el-width-200" filterable @change="insertDiscountPriceTypeChange">
            <el-option v-for="item in constant.discountBillingTypes" :key="item.value" :value="item.value" :label="item.label"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="起步价：" v-show="dialogInsertDiscount.form.StartPriceShow">
          <el-input size="mini" type="number" placeholder="请填写起步价" v-model="dialogInsertDiscount.form.StartPrice" class="el-width-200"></el-input>
        </el-form-item>
        <el-form-item label="百分比：" v-show="dialogInsertDiscount.form.PercentShow">
          <el-input size="mini" type="number" placeholder="百分比" v-model="dialogInsertDiscount.form.Percent" class="el-width-200"></el-input>
        </el-form-item>
        <el-form-item label="目标计费类型：" v-show="dialogInsertDiscount.form.TargetPriceTypeShow">
          <el-select size="mini" placeholder="请选择目标计费类型" v-model="dialogInsertDiscount.form.TargetPriceTypeId" class="el-width-200" filterable>
            <el-option v-for="item in dialogInsertDiscount.pricetypelist" :key="item.value" :value="item.value" :label="item.label"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="值单位：" v-show="dialogInsertDiscount.form.ValueUnitShow">
          <el-input size="mini" type="number" placeholder="请填写值单位" v-model="dialogInsertDiscount.form.ValueUnit" class="el-width-200"></el-input>
        </el-form-item>
        <el-form-item label="单价：" v-show="dialogInsertDiscount.form.UnitPriceShow">
          <el-input size="mini" type="number" placeholder="请填写单价" v-model="dialogInsertDiscount.form.UnitPrice" class="el-width-200"></el-input>
        </el-form-item>
        <el-form-item label="计算模式：">
          <el-checkbox v-model="dialogInsertDiscount.form.ManualCalcu">手动</el-checkbox>
        </el-form-item>
        <div class="clear"></div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="dialogInsertDiscountSave">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="dialogImportDiscount.dialogtitle" :visible.sync="dialogImportDiscount.dialogvisible" :modal-append-to-body="false" center width="700px">
      <el-form :model="dialogImportDiscount.form" :rules="dialogImportDiscount.form.rules" :ref="dialogImportDiscount.form.formname" label-width="100px" class="el-form-half etms-dialog-form">
        <el-form-item label="供应商：">
          <el-select size="mini" placeholder="请选择供应商" v-model="dialogImportDiscount.form.SupplyId" class="el-width-200" filterable>
            <el-option v-for="item in supplylist" :key="item.value" :value="item.value" :label="item.label"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="渠道：">
          <el-select size="mini" placeholder="请选择渠道" v-model="dialogImportDiscount.form.ChannelId" class="el-width-200" filterable>
            <el-option v-for="item in dialogImportDiscount.channellist" :key="item.value" :value="item.value" :label="item.label"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="折扣版本：">
          <el-select size="mini" placeholder="请选择折扣版本" v-model="dialogImportDiscount.form.DiscountVersionId" class="el-width-200" filterable>
            <el-option v-for="item in dialogImportDiscount.discountversionlist" :key="item.value" :value="item.value" :label="item.label"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="包裹类型：">
          <el-select size="mini" placeholder="请选择包裹类型" v-model="dialogImportDiscount.form.ParcelTypeId" class="el-width-200" filterable>
            <el-option v-for="item in dialogImportDiscount.parceltypelist" :key="item.value" :value="item.value" :label="item.label"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="模版：" prop="Template">
          <el-select size="mini" placeholder="请选择模版进行导入" v-model="dialogImportDiscount.form.TemplateId" class="el-width-200" filterable>
            <el-option v-for="item in constant.priceImportTemplates" :key="item.value" :value="item.value" :label="item.label"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="文件" class="clear el-width-fill">
          <el-upload class="upload-demo" ref="upload" :action="constant.openPaths.fileupload" :before-remove="beforeRemove" :limit="1" :on-exceed="handleExceed" :file-list="dialogImportDiscount.form.fileList" :auto-upload="false" list-type="text">
            <el-button slot="trigger" size="small" type="primary">选择文件</el-button>
            <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且不超过2mb</div>
          </el-upload>
        </el-form-item>
        <div class="clear"></div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" type="success" @click="dialogImportDiscountSave">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="dialogDeleteDiscount.dialogtitle" :visible.sync="dialogDeleteDiscount.dialogvisible" :modal-append-to-body="false" center width="700px">
      <el-form :model="dialogDeleteDiscount.form" :rules="dialogDeleteDiscount.form.rules" :ref="dialogDeleteDiscount.form.formname" label-width="120px" class="el-form-half etms-dialog-form">
        <el-form-item label="供应商：">
          <el-select size="mini" placeholder="请选择供应商" v-model="dialogDeleteDiscount.form.SupplyId" class="el-width-200" filterable>
            <el-option v-for="item in supplylist" :key="item.value" :value="item.value" :label="item.label"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="渠道：">
          <el-select size="mini" placeholder="请选择渠道" v-model="dialogDeleteDiscount.form.ChannelId" class="el-width-200" filterable>
            <el-option v-for="item in dialogInsertDiscount.channellist" :key="item.value" :value="item.value" :label="item.label"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="折扣版本：">
          <el-select size="mini" placeholder="请选择折扣版本" v-model="dialogDeleteDiscount.form.DiscountVersionId" class="el-width-200" filterable>
            <el-option v-for="item in dialogInsertDiscount.discountversionlist" :key="item.value" :value="item.value" :label="item.label"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="包裹类型：">
          <el-select size="mini" placeholder="请选择包裹类型" v-model="dialogDeleteDiscount.form.ParcelTypeIds" class="el-width-200" filterable multiple collapse-tags>
            <el-option v-for="item in dialogInsertDiscount.parceltypelist" :key="item.value" :value="item.value" :label="item.label"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="渠道线路：">
          <el-select size="mini" placeholder="请选择渠道线路" v-model="dialogDeleteDiscount.form.ChannelLineIds" class="el-width-200" filterable multiple collapse-tags>
            <el-option v-for="item in dialogInsertDiscount.channellinelist" :key="item.value" :value="item.value" :label="item.label"></el-option>
          </el-select>
        </el-form-item>
        <div class="clear"></div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" type="success" @click="dialogDeleteDiscountSave">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      userinfo: this.$cookies.get('userinfo'),
      activename: 'versionmanage',
      supplylist: [],
      channellist: [],
      version: {
        search: {
          ChannelSupplyId: '',
          ChannelId: '',
          Version: '',
          channellist: [],
        },
        versionlist: [],
        dialogVersion: {
          dialogtitle: '添加折扣版本',
          dialogvisible: false,
          channellist: [],
          priceversionlist: [],
          form: {
            formname: 'versionform',
            Id: '',
            OptimisticLock: '',
            ChannelSupplyId: '',
            ChannelId: '',
            PriceVersionId: '',
            Version: '',
            EffectTime: [],
            State: 1,
            rules: {
              ChannelSupplyId: [
                { required: true, message: '请选择供应商', trigger: 'change' }
              ],
              ChannelId: [
                { required: true, message: '请选择渠道', trigger: 'change' }
              ],
              PriceVersionId: [
                { required: true, message: '请选择价格版本', trigger: 'change' }
              ],
              Version: [
                { required: true, message: '版本号不可为空', trigger: 'blur' },
                { max: 30, message: '版本号不能超过30个字', trigger: 'blur' }
              ],
              EffectTime: [
                { required: true, message: '请选择生效时间段', trigger: 'blur' },
              ],
              State: [
                { required: true, message: '状态不可为空', trigger: 'change' },
              ]
            }
          }
        },
      },
      discount: {
        search: {
          ChannelSupplyId: '',
          ChannelId: '',
          Version: '',
          ItemType: '',
          ChannelLineId: '',
          channellist: [],
          versionlist: [],
          itemtypelist: [],
          channellinelist: [],
          channellinepurposelist:[],
          pricelist: [
            {
              PriceTypeId: '0',
              PriceTypeName: '运费',
              DiscountList: [
                {
                  DiscountId: '0-0',
                  StartValue: 0,
                  EndValue: 0.15,
                  PriceBillingType: '直乘',
                  StartPrice: 0,
                  Percent: 0,
                  ValueUnit: 1,
                  UnitPrice: 75,
                  ManualCalcu: false,
                },
              ]
            }
          ],
        }
      },
      dialogPassDiscount: {
        dialogtitle: '通折设置',
        dialogvisible: false,
        activename: 'baseinfo',
        channellist: [
          { label: '广州小包', value: '0' },
        ],
        discountversionlist: [
          { label: '一套价格', value: '0' },
        ],
        parceltypelist: [
          { label: '物品', value: '0' },
          { label: '文件', value: '1' },
        ],
        channellinelist: [
          { label: '一区', value: '0' },
          { label: '二区', value: '1' },
          { label: '三区', value: '2' },
        ],
        form: {
          SupplyId: '',
          ChannelId: '',
          DiscountVersion: '',
          ParcelTypeIds: [],
          ChannelLineIds: [],
          discountlist: [],
          rules: {
            StartValue: [
              { required: true, message: '错误', trigger: 'blur' }
            ]
          },
        },

      },
      dialogDiscountBatchSetting: {
        dialogtitle: '折扣批量设置',
        dialogvisible: false,
        activename: 'baseinfo',
        channellist: [
          { label: '广州小包', value: '0' },
        ],
        discountversionlist: [
          { label: '一套价格', value: '0' },
        ],
        parceltypelist: [
          { label: '物品', value: '0' },
          { label: '文件', value: '1' },
        ],
        channellinelist: [
          { label: '一区', value: '0' },
          { label: '二区', value: '1' },
          { label: '三区', value: '2' },
        ],
        pricetypelist: [
          { label: '运费', value: '0' },
          { label: '挂号费', value: '1' },
          { label: '报关费', value: '2' },
        ],
        form: {
          formname: 'batchsettingform',
          SupplyId: '',
          ChannelId: '',
          VersionId: '',
          channellinelist: [],
          parceltypelist: [],
          discountlist: [
            {
              StartValue: 0,
              EndValue: 0,
              PriceBillingType: '',
              StartShow: false,
              StartPrice: 0,
              PercentShow: false,
              Percent: 0,
              ValueUnitShow: false,
              ValueUnit: 0,
              UnitPriceShow: false,
              UnitPrice: 0,
              ManualCalcu: false,
              TargetShow: false,
              TargetPriceTypeId: '',
            }
          ],
          rules: {},
        },
      },
      dialogInsertDiscount: {
        dialogtitle: '添加折扣',
        dialogvisible: false,
        channellist: [
          { label: '广州小包', value: '0' },
        ],
        discountversionlist: [
          { label: '一套价格', value: '0' },
        ],
        parceltypelist: [
          { label: '物品', value: '0' },
          { label: '文件', value: '1' },
        ],
        channellinelist: [
          { label: '一区', value: '0' },
          { label: '二区', value: '1' },
          { label: '三区', value: '2' },
        ],
        pricetypelist: [
          { label: '运费', value: '0' },
          { label: '挂号费', value: '1' },
          { label: '报关费', value: '2' },
        ],
        form: {
          formname: 'insertdiscountform',
          SupplyId: '',
          ChannelId: '',
          DiscountVersionId: '',
          ChannelLineId: '',
          ParcelTypeId: '',
          StartValue: 0,
          EndValue: 0,
          PriceTypeId: '0',
          PriceBillingType: 0,
          StartPrice: 0,
          StartPriceShow: false,
          Percent: 0,
          PercentShow: false,
          TargetPriceTypeId: '',
          TargetPriceTypeShow: false,
          ValueUnit: 0,
          ValueUnitShow: false,
          UnitPrice: 0,
          UnitPriceShow: false,
          ManualCalcu: false
        }
      },
      dialogImportDiscount: {
        dialogtitle: '导入折扣',
        dialogvisible: false,
        channellist: [
          { label: '广州小包', value: '0' },
        ],
        discountversionlist: [
          { label: '一套价格', value: '0' },
        ],
        parceltypelist: [
          { label: '物品', value: '0' },
          { label: '文件', value: '1' },
        ],
        form: {
          formname: 'importdiscountform',
          SupplyId: '',
          ChannelId: '',
          DiscountVersionId: '',
          ParcelTypeId: '',
          TemplateId: '',
          fileList: [],
          rules: {},
        }
      },
      dialogDeleteDiscount: {
        dialogtitle: '删除折扣',
        dialogvisible: false,
        channellist: [
          { label: '广州小包', value: '0' },
        ],
        discountversionlist: [
          { label: '一套价格', value: '0' },
        ],
        parceltypelist: [
          { label: '物品', value: '0' },
          { label: '文件', value: '1' },
        ],
        channellinelist: [
          { label: '一区', value: '0' },
          { label: '二区', value: '1' },
          { label: '三区', value: '2' },
        ],
        form: {
          formname: 'deletediscountform',
          SupplyId: '',
          ChannelId: '',
          DiscountVersionId: '',
          ParcelTypeIds: [],
          ChannelLineIds: [],
          rules: {}
        }
      },
    }
  },
  computed: {
    newVersionSearchSupply () {
      return this.version.search.ChannelSupplyId
    },
    newVersionInsertSupply () {
      return this.version.dialogVersion.form.ChannelSupplyId
    },
    newVersionInsertChannel () {
      return this.version.dialogVersion.form.ChannelId
    },
    newDiscountChannelSupply () {
      return this.discount.search.ChannelSupplyId
    },
    newDiscountChannel () {
      return this.discount.search.ChannelId
    },
    newChannelLine(){
      return this.discount.search.ChannelLineId
    }
  },
  watch: {
    newVersionSearchSupply () {
      this.versionSupplyChange()
    },
    newVersionInsertSupply () {
      this.insertVersionSupplyChange()
    },
    newVersionInsertChannel () {
      this.searchPriceVersion()
    },
    newDiscountChannelSupply () {
      this.discountChannelSupplyChange()
    },
    newDiscountChannel () {
      this.searchItemType()
      this.searchDiscountVersion()
      this.searchChannelLine()
    },
    newChannelLine(){
      this.searchChannelLinePurpose()
    }
  },
  mounted () {
    this.initChannelSupply()
    this.initChannel()
    this.searchVersionClick()
  },
  methods: {
    clearForm (form) {
      Object.keys(form).forEach(item => {
        if (item !== 'formname') {
          switch (typeof (form[item])) {
            case 'string':
              form[item] = ''
              break
            case 'number':
              form[item] = ''
              break
            case 'object':
              if (Array.isArray(form[item])) {
                form[item] = []
              } else { }
              break
          }
        }
      })
    },
    initChannelSupply () {
      if (this.userinfo !== null && this.userinfo !== undefined) {
        var data = {
          UserId: this.userinfo.id,
          EnterpriseId: this.userinfo.enterpriseId,
          LoginToken: this.userinfo.loginToken
        }
        var self = this
        this.$ajax.post(this.constant.openPaths.searchEnterpriseChannelSupply, data).then(res => {
          switch (res.data.code) {
            case 200:
              self.supplylist = res.data.result
              break;
            case 402:
              self.$router.push({ name: 'login' })
              break
            default:
              self.$message.error(res.data.msg)
              break;
          }
        }).catch(error => {
          self.$message.error(error)
        })
      }
    },
    initChannel () {
      if (this.userinfo !== null && this.userinfo !== undefined) {
        var data = {
          UserId: this.userinfo.id,
          EnterpriseId: this.userinfo.enterpriseId,
          LoginToken: this.userinfo.loginToken
        }
        var self = this
        this.$ajax.post(this.constant.openPaths.getChannelList, data).then(res => {
          switch (res.data.code) {
            case 200:
              self.channellist = res.data.result
              break;
            case 402:
              self.$router.push({ name: 'login' })
              break
            default:
              self.$message.error(res.data.msg)
              break;
          }
        }).catch(error => {
          self.$message.error(error)
        })
      }
    },
    versionSupplyChange () {
      var supply = this.supplylist.filter(item => item.id === this.version.search.ChannelSupplyId)[0]
      this.version.search.channellist = []
      if (supply !== null && supply !== undefined) {
        this.version.search.channellist = this.channellist.filter(item => supply.channelMappingList.some(t => t.channelId === item.id))
      }
    },
    insertVersionSupplyChange () {
      var supply = this.supplylist.filter(item => item.id === this.version.dialogVersion.form.ChannelSupplyId)[0]
      this.version.dialogVersion.channellist = []
      if (supply !== null && supply !== undefined) {
        this.version.dialogVersion.channellist = this.channellist.filter(item => supply.channelMappingList.some(t => t.channelId === item.id))
      }
    },
    searchPriceVersion () {
      if (this.userinfo !== null && this.userinfo !== undefined) {
        var data = {
          UserId: this.userinfo.id,
          EnterpriseId: this.userinfo.enterpriseId,
          LoginToken: this.userinfo.loginToken,
          ChannelId: this.version.dialogVersion.form.ChannelId
        }
        var self = this
        this.$ajax.post(this.constant.openPaths.searchChannelPriceVersion, data).then(res => {
          switch (res.data.code) {
            case 200:
              self.version.dialogVersion.priceversionlist = res.data.result
              break;
            case 402:
              self.$router.push({ name: 'login' })
              break
            default:
              self.$message.error(res.data.msg)
              break;
          }
        }).catch(error => { self.$message.error(error) })
      } else {
        this.$router.push({ name: 'login' })
      }
    },
    searchVersionClick () {
      if (this.userinfo !== null && this.userinfo !== undefined) {
        var data = {
          UserId: this.userinfo.id,
          EnterpriseId: this.userinfo.enterpriseId,
          LoginToken: this.userinfo.loginToken,
          ChannelSupplyId: this.version.search.ChannelSupplyId,
          ChannelId: this.version.search.ChannelId,
          Version: this.version.search.Version
        }
        var self = this
        this.$ajax.post(this.constant.openPaths.searchChannelSupplyDiscountVersion, data).then(res => {
          switch (res.data.code) {
            case 200:
              self.version.versionlist = res.data.result
              break;
            case 402:
              self.$router.push({ name: 'login' })
              break
            default:
              self.$message.error(res.data.msg)
              break;
          }
        }).catch(error => { self.$message.error(error) })
      } else {
        this.$router.push({ name: 'login' })
      }
    },
    insertVersion () {
      this.version.dialogVersion.dialogvisible = true
      this.version.dialogVersion.dialogtitle = '添加折扣版本'
    },
    dialogVersionSave () {
      if (this.userinfo !== null && this.userinfo !== undefined) {
        var data = {
          UserId: this.userinfo.id,
          EnterpriseId: this.userinfo.enterpriseId,
          LoginToken: this.userinfo.loginToken,
          Id: this.version.dialogVersion.form.Id,
          OptimisticLock: this.version.dialogVersion.form.OptimisticLock,
          ChannelSupplyId: this.version.dialogVersion.form.ChannelSupplyId,
          ChannelId: this.version.dialogVersion.form.ChannelId,
          PriceVersionId: this.version.dialogVersion.form.PriceVersionId,
          Version: this.version.dialogVersion.form.Version,
          StartTakeEffectTime: new Date(this.version.dialogVersion.form.EffectTime[0]).toLocaleString(),
          EndTakeEffectTime: new Date(this.version.dialogVersion.form.EffectTime[1]).toLocaleString(),
          State: this.version.dialogVersion.form.State
        }
        var url = ''
        if (data.Id === '' && data.OptimisticLock === '') {
          url = this.constant.openPaths.insertChannelSupplyDiscountVersion
        } else {
          url = this.constant.openPaths.updateChannelSupplyDiscountVersion
        }

        var self = this
        this.$refs[this.version.dialogVersion.form.formname].validate((valid) => {
          if (valid) {
            self.$ajax.post(url, data).then(res => {
              switch (res.data.code) {
                case 200:
                  self.$message({ message: res.data.msg, type: 'success' })
                  self.clearForm(self.version.dialogVersion.form)
                  self.searchVersionClick()
                  self.version.dialogVersion.dialogvisible = false
                  break;
                case 402:
                  self.$router.push({ name: 'login' })
                  break
                default:
                  self.$message.error(res.data.msg)
                  break;
              }
            }).catch(error => {
              self.$message.error(error)
            })
          }
        })
      } else {
        this.$router.push({ name: 'login' })
      }
    },
    handleClick (tab, event) {
      if (tab.name === 'discountmanage') {
        if (this.supplylist.length > 0) {
          this.discount.search.ChannelSupplyId = this.supplylist[0].id
        }
      }
      console.log(tab.name)
    },
    discountChannelSupplyChange () {
      var supply = this.supplylist.filter(item => item.id === this.discount.search.ChannelSupplyId)[0]
      this.discount.search.channellist = []
      if (supply !== null && supply !== undefined) {
        this.discount.search.channellist = this.channellist.filter(item => supply.channelMappingList.some(t => t.channelId === item.id))
        if (this.discount.search.channellist.length > 0) {
          this.discount.search.ChannelId = this.discount.search.channellist[0].id
        }
      }
    },
    searchItemType () {
      var itemtypes = []
      var channel = this.channellist.filter(item => item.id === this.discount.search.ChannelId)[0]
      if (channel !== null && channel !== undefined && channel.itemTypes !== null && channel.itemTypes !== undefined) {
        this.discount.search.itemtypelist = this.constant.itemtypes.filter(item => channel.itemTypes.some(t => t === item.value))
        if (this.discount.search.itemtypelist.length > 0) {
          this.discount.search.ItemType = this.discount.search.itemtypelist[0].value
        }
      }
    },
    searchDiscountVersion () {
      if (this.userinfo !== undefined && this.userinfo !== null) {
        var data = {
          UserId: this.userinfo.id,
          EnterpriseId: this.userinfo.enterpriseId,
          LoginToken: this.userinfo.loginToken,
          ChannelSupplyId: this.discount.channelSupplyId,
          ChannelId: this.discount.search.ChannelId
        }
        var self = this
        this.$ajax.post(this.constant.openPaths.searchChannelSupplyDiscountVersion, data).then(res => {
          switch (res.data.code) {
            case 200:
              self.discount.search.versionlist = res.data.result
              if (res.data.result.length > 0) {
                self.discount.search.Version = res.data.result[0].id
              } else {
                self.discount.search.Version = ''
              }
              break;
            case 402:
              self.$router.push({ name: 'login' })
              break
            default:
              self.$message.error(res.data.msg)
              break;
          }
        }).catch(error => {
          self.$message.error(error)
          self.discount.search.versionlist = []
          self.discount.search.Version = ''
        })
      }
      else {
        this.$router.push({ name: 'login' })
      }
    },
    searchChannelLine () {
      if (this.userinfo !== undefined && this.userinfo !== null) {
        var data = {
          UserId: this.userinfo.id,
          EnterpriseId: this.userinfo.enterpriseId,
          LoginToken: this.userinfo.loginToken,
          ChannelId: this.discount.search.ChannelId
        }
        var self = this
        this.$ajax.post(this.constant.openPaths.searchChannelLine, data).then(res => {
          switch (res.data.code) {
            case 200:
              self.discount.search.channellinelist = res.data.result
              if (res.data.result.length > 0) {
                self.discount.search.ChannelLineId = res.data.result[0].id
              } else {
                self.discount.search.ChannelLineId = ''
              }
              break;
            case 402:
              self.$router.push({ name: 'login' })
              break
            default:
              self.$message.error(res.data.msg)
              break;
          }
        }).catch(error => {
          self.$message.error(error)
          self.discount.search.channellinelist = []
          self.discount.search.ChannelLineId = ''
        })
      }
      else {
        this.$router.push({ name: 'login' })
      }
    },
    searchChannelLinePurpose () {
      if (this.userinfo !== undefined && this.userinfo !== null) {
        var data = {
          UserId: this.userinfo.id,
          EnterpriseId: this.userinfo.enterpriseId,
          LoginToken: this.userinfo.loginToken,
          ChannelId: this.discount.search.ChannelId,
          ChannelLineId: this.discount.search.ChannelLineId
        }
        var self = this
        this.$ajax.post(this.constant.openPaths.searchChannelLinePurpose, data).then(res => {
          switch (res.data.code) {
            case 200:
              self.discount.search.channellinepurposelist = res.data.result

              break;
            case 402:
              self.$router.push({ name: 'login' })
              break
            default:
              self.$message.error(res.data.msg)
              break;
          }
        }).catch(error => {
          self.$message.error(error)
        })
      }
      else {
        this.$router.push({ name: 'login' })
      }
    },
    formatterSupplyName (row, column) {
      var supplymodel = this.supplylist.filter(item => item.id === row.channelSupplyId)[0]
      if (supplymodel !== null && supplymodel !== undefined) {
        return supplymodel.channelSupplyName
      }
      return ''
    },
    formatterVersionChannelName (row, column) {
      var channelmodel = this.channellist.filter(item => item.id === row.channelId)[0]
      if (channelmodel !== null && channelmodel !== undefined) {
        return channelmodel.channelName
      }
      return ''
    },
    formatterEffectTime (row, column) {
      return new Date(row.startTakeEffectTime).toLocaleString() + ' 至 ' + new Date(row.endTakeEffectTime).toLocaleString()
    },
    formatterState (row, column) {
      var state = this.constant.discountVersionStates.filter(item => item.value === row.state)[0]
      if (state !== undefined && state !== null) { return state.label }
      return ''
    },
    editVersion (row) {
      this.version.dialogVersion.dialogtitle = '修改版本'
      this.version.dialogVersion.dialogvisible = true
      this.version.dialogVersion.form.Id = row.id
      this.version.dialogVersion.form.OptimisticLock = row.optimisticLock
      this.version.dialogVersion.form.ChannelSupplyId = row.channelSupplyId
      this.version.dialogVersion.form.ChannelId = row.channelId
      this.version.dialogVersion.form.PriceVersionId = row.priceVersionId
      this.version.dialogVersion.form.Version = row.version
      this.version.dialogVersion.form.EffectTime = [row.startTakeEffectTime, row.endTakeEffectTime]
      this.version.dialogVersion.form.State = row.state
    },
    deleteVersion (row) {
      if (this.userinfo !== undefined && this.userinfo !== null) {
        var data = {
          UserId: this.userinfo.id,
          EnterpriseId: this.userinfo.enterpriseId,
          LoginToken: this.userinfo.loginToken,
          Id: row.id,
          OptimisticLock: row.optimisticLock,
        }
        var self = this
        this.$confirm('此操作将永久删除该版本及该版本下的折扣,是否继续？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          self.$ajax.post(self.constant.openPaths.deleteChannelSupplyDiscountVersion, data).then(res => {
            switch (res.data.code) {
              case 200:
                self.$message({ message: res.data.msg, type: 'success' })
                self.searchVersionClick()
                break;
              case 402:
                self.$router.push({ name: 'login' })
                break
              default:
                self.$message.error(res.data.msg)
                break;
            }
          }).catch(error => { self.$message.error(error) })
        })
      }
      else {
        this.$router.push({ name: 'login' })
      }
    },
    searchDiscount () { },
    handleCommand (val) {
      switch (val) {
        case 'passdiscountsetting':
          this.dialogPassDiscount.dialogvisible = true
          break
        case 'discountbatchsetting':
          this.dialogDiscountBatchSetting.dialogvisible = true
          break
        case 'insertdiscount':
          this.dialogInsertDiscount.dialogvisible = true
          break
        case 'importdiscount':
          this.dialogImportDiscount.dialogvisible = true
          break
        case 'deletediscount':
          this.dialogDeleteDiscount.dialogvisible = true
          break
        default:
          break
      }
    },
    editDiscount (row) { },
    deleteDiscount (row) { },
    insertPassDiscountList () {
      this.dialogPassDiscount.form.discountlist.push({})
    },
    deletePassDiscountList (index) {
      this.dialogPassDiscount.form.discountlist.splice(index, 1)
    },
    dialogPassDiscountSave () { },
    priceBillingTypeChange (row) {
      row.StartShow = false
      row.PercentShow = false
      row.TargetShow = false
      row.ValueUnitShow = false
      row.UnitPriceShow = false
      switch (row.PriceBillingType) {
        case 0:
          row.StartShow = true
          break
        case 1:
          row.StartShow = true
          row.ValueUnitShow = true
          row.UnitPriceShow = true
          break
        case 2:
        case 3:
          row.ValueUnitShow = true
          row.UnitPriceShow = true
          break
        case 4:
          row.PercentShow = true
          row.TargetShow = true
          break
        case 5:
          row.PercentShow = true
          break
        default:
          break
      }
    },
    insertBarchSettingDiscount () {
      this.dialogDiscountBatchSetting.form.discountlist.push({})
    },
    deleteBarchSettingDiscount (index) {
      this.dialogDiscountBatchSetting.form.discountlist.splice(index, 1)
    },
    dialogBatchSettingSave () { },
    insertDiscountPriceTypeChange () {
      this.dialogInsertDiscount.form.StartPriceShow = false
      this.dialogInsertDiscount.form.PercentShow = false
      this.dialogInsertDiscount.form.TargetPriceTypeShow = false
      this.dialogInsertDiscount.form.ValueUnitShow = false
      this.dialogInsertDiscount.form.UnitPriceShow = false
      switch (this.dialogInsertDiscount.form.PriceBillingType) {
        case 0:
          this.dialogInsertDiscount.form.StartPriceShow = true
          break
        case 1:
          this.dialogInsertDiscount.form.StartPriceShow = true
          this.dialogInsertDiscount.form.ValueUnitShow = true
          this.dialogInsertDiscount.form.UnitPriceShow = true
          break
        case 2:
        case 3:
          this.dialogInsertDiscount.form.ValueUnitShow = true
          this.dialogInsertDiscount.form.UnitPriceShow = true
          break
        case 4:
          this.dialogInsertDiscount.form.PercentShow = true
          this.dialogInsertDiscount.form.TargetPriceTypeShow = true
          break
        case 5:
          this.dialogInsertDiscount.form.PercentShow = true
          break
        default:
          break
      }
    },
    dialogInsertDiscountSave () { },
    handleExceed (files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    beforeRemove (file, fileList) {
    },
    dialogImportDiscountSave () { },
    dialogDeleteDiscountSave () { },
  }
}
</script>

<style scoped>
@import "../../../css/etms/home.css";
@import "../../../css/iconfont.css";
</style>



// WEBPACK FOOTER //
// src/components/etms/tms/supplier_discount_setting.vue